module.exports = __webpack_public_path__ + "images/44a13507.minions.png";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/orderLocation/images/minions.png
// module id = 550
// module chunks = 99